<template>
  <div class="body-div">
    <div class="top-div">
      <div class="table">
        <table v-for="question in answersDataToday" :key="question">
          <thead>
            <tr class="tr-question">
              {{
                question.full_question.question | truncate(23)
              }}
            </tr>
          </thead>
          <thead>
            <tr class="text-center">
              <th>Answer</th>
              <th class="td-count">TODAY</th>
              <!--            <th class="td-count">THIS MONTH</th>
            <th class="td-count">LAST MONTH</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="answer in question.assoc" :key="answer.id">
              <td>{{ answer.full_answer.answer | truncate(13) }}</td>
              <td class="td-count">{{ answer.count_today }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="table">
        <table v-for="question in answersDataMonth" :key="question">
          <thead>
            <!--   <tr class="tr-question">          {{question.full_question.question | truncate(18)}} </tr>-->
          </thead>
          <thead>
            <tr class="text-center">
              <th>Answer</th>
              <th class="td-count">MONTH</th>
              <!--            <th class="td-count">THIS MONTH</th>
          <th class="td-count">LAST MONTH</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="answer in question.assoc" :key="answer.id">
              <td>{{ answer.full_answer.answer | truncate(13) }}</td>
              <td class="td-count">{{ answer.count_month }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="table">
        <table v-for="question in answersDataLastMonth" :key="question">
          <thead>
            <!--
          <tr class="tr-question">          {{question.full_question.question | truncate(18)}} </tr>
-->
          </thead>
          <thead>
            <tr class="text-center">
              <th>Answer</th>
              <th class="td-count">LAST MONTH</th>
              <!--            <th class="td-count">THIS MONTH</th>
          <th class="td-count">LAST MONTH</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="answer in question.assoc" :key="answer.id">
              <td>{{ answer.full_answer.answer | truncate(10) }}</td>
              <td class="td-count">{{ answer.count_last_month }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flat-bottom-div">
        <div class="paginationContainer text-center">
          <div class="btn-group ">
            <button
              v-if="pageNum !== 1"
              @click="backPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="pageNum === 1"
            >
              <i class="fa fa-chevron-left"></i>
            </button>
            <span class="btn btn-sm s-btn-sm page-num ">
              {{ pageNum }}
            </span>
            <button
              v-if="paginate(answersDataToday, pageNum + 1, 26).length !== 0"
              @click="nextPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="
                paginate(answersDataToday, pageNum + 1, 26).length === 0
              "
            >
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="fab"><span class="fas fa-file-csv"></span></div>
      </div>

      <loader class="loader" :size="'8px'" v-if="reqAnswersTodayBusy"></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >

      <loader :size="'11px'" v-if="reqReportsBusy"></loader>

      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "Questions.container",
  components: { Loader },
  data() {
    return {
      reqReportsBusy: false,
      reqAnswersTodayBusy: false,
      reqAnswersMonthBusy: false,
      reqAnswersLastMonthBusy: false,
      pageNum: 1,
      answersDataToday: [],
      answersDataMonth: [],
      answersDataLastMonth: [],

      campTabs: [
        {
          id: 0,
          name: "GLOBAL",
          alias: "GLOBAL"
        },
        {
          id: 1,
          name: "COUNTRIES",
          alias: "COUNTRIES"
        }
      ],
      selectedCampTab: "GLOBAL",
      arr: [[]]
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries"])
  },
  created() {
    this.getAnswersToday();
    this.getAnswersMonth();
    this.getAnswersLastMonth();
  },
  methods: {
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    paginate(arr, page_number, page_size) {
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },
    nextPage() {
      this.pageNum = this.pageNum + 1;
    },
    backPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },
    getAnswersToday() {
      if (
        !this.reqAnswersTodayBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        this.reqAnswersTodayBusy = true;
        apiClientCreator(`reports/questions/today`)
          // .get("", { params: this.queryObject })
          .get("")
          .then(res => {
            this.answersDataToday = res.data;
            this.answersDataToday.sort((a, b) => {
              if (a.count_today > b.count_today) {
                return -1;
              }
              if (a.count_today < b.count_today) {
                return 1;
              }
              return 0;
            });
            this.reqAnswersTodayBusy = false;
          })
          .catch(err => {
            this.reqAnswersTodayBusy = false;
          });
      }
    },
    getAnswersMonth() {
      if (
        !this.reqAnswersMonthBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        this.reqAnswersMonthBusy = true;
        apiClientCreator(`reports/questions/month`)
          // .get("", { params: this.queryObject })
          .get("")
          .then(res => {
            this.answersDataMonth = res.data;
            this.answersDataMonth.sort((a, b) => {
              if (a.count_month > b.count_month) {
                return -1;
              }
              if (a.count_month < b.count_month) {
                return 1;
              }
              return 0;
            });
            this.reqAnswersMonthBusy = false;
          })
          .catch(err => {
            this.reqAnswersMonthBusy = false;
          });
      }
    },
    getAnswersLastMonth() {
      if (
        !this.reqAnswersLastMonthBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        this.reqAnswersLastMonthBusy = true;
        apiClientCreator(`reports/questions/last_month`)
          // .get("", { params: this.queryObject })
          .get("")
          .then(res => {
            this.answersDataLastMonth = res.data;
            this.answersDataLastMonth.sort((a, b) => {
              if (a.count_last_month > b.count_last_month) {
                return -1;
              }
              if (a.count_last_month < b.count_last_month) {
                return 1;
              }
              return 0;
            });
            this.reqAnswersLastMonthBusy = false;
          })
          .catch(err => {
            this.reqAnswersLastMonthBusy = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 15px 5px 5px 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  /* float: left;*/
  display: inline-flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.table table {
  font-size: 12px;
  width: 450px;
  /*   margin-right: auto;*/
  margin-left: 7px;
  margin-right: 7px;
}
/*.ca-auto-status-override{
  width: 355px !important;
}
.ca-regular-status-override{
  width: 450px !important;
}*/
.table thead {
  border-bottom: solid 2px #eff3f6;
  position: relative;
}
.table th {
  text-align: left;
  font-size: 12px;
}
.table .td-count {
  text-align: center;
}
.table td {
  border-bottom: solid 2px #eff3f6;
}
.table thead .tr-question {
  top: 38px;
  position: absolute;
  background: #44a2d2;
  color: white;
  padding: 2px;
  width: 100%;
}
.text-center {
  font-weight: bold;
}

.paginationContainer {
  /*margin-left: 10px;*/
  font-size: 15px;
  width: 110px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}
.loader {
  position: absolute;
  top: 100px;

  left: 0;
  right: 0;
}
.flat-bottom-div {
  margin-top: 10px;
  height: 40px;
  width: 100%;
}

/*.table table {
  font-size: 13px;
  width: 200px;
  margin-right: auto;
  margin-left: auto;

}
.table tbody{
  display: block;
  height: 332px;
  overflow: auto;
  width: 100%

}
.table thead tr {
  border-bottom: solid 2px #eff3f6;
  position: relative;

}*/
</style>
